import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { PageHeader, Panel } from "@/components/common";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg, TOKEN_KEY } from "@/lib/api";

const Field = ({ id, label, ...props }) => (
  <div><Label htmlFor={id}>{label}</Label><Input id={id} className="mt-1.5" data-testid={`profile-${id}-input`} {...props} /></div>
);

const PasswordForm = () => {
  const [pw, setPw] = useState({ current_password: "", new_password: "" });
  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/change-password", pw);
      localStorage.setItem(TOKEN_KEY, data.token);
      toast.success("Password changed");
      setPw({ current_password: "", new_password: "" });
    } catch (err) {
      toast.error(errMsg(err));
    }
  };
  return (
    <form onSubmit={submit} className="space-y-4">
      <Field id="current-password" label="Current password" type="password" required value={pw.current_password} onChange={(e) => setPw({ ...pw, current_password: e.target.value })} />
      <Field id="new-password" label="New password" type="password" minLength={8} required value={pw.new_password} onChange={(e) => setPw({ ...pw, new_password: e.target.value })} />
      <Button type="submit" variant="outline" data-testid="change-password-button">Change password</Button>
    </form>
  );
};

export default function Profile() {
  const { user, setUser } = useAuth();
  const a = user.agency || {};
  const [f, setF] = useState({ name: user.name || "", agency_name: a.name || "", phone: a.phone || "", country: a.country || "", website: a.website || "", description: a.description || "" });
  const isAgency = user.role === "agency";
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    try {
      setUser((await api.put("/auth/profile", f)).data);
      toast.success("Profile saved");
    } catch (err) {
      toast.error(errMsg(err));
    }
  };

  return (
    <div>
      <PageHeader eyebrow="Account" title="Profile" subtitle={user.email} />
      <div className="grid lg:grid-cols-[1fr_380px] gap-6 items-start">
        <Panel title={isAgency ? "Agency details" : "Your details"}>
          <form onSubmit={save} className="grid sm:grid-cols-2 gap-4">
            <Field id="name" label="Your name" required value={f.name} onChange={set("name")} />
            {isAgency && <>
              <Field id="agency-name" label="Agency name" value={f.agency_name} onChange={set("agency_name")} />
              <Field id="phone" label="Phone" value={f.phone} onChange={set("phone")} />
              <Field id="country" label="Country" value={f.country} onChange={set("country")} />
              <div className="sm:col-span-2"><Field id="website" label="Website" value={f.website} onChange={set("website")} /></div>
              <div className="sm:col-span-2"><Label htmlFor="desc">About your agency</Label><Textarea id="desc" rows={3} className="mt-1.5" data-testid="profile-description-input" value={f.description} onChange={set("description")} /></div>
            </>}
            <div className="sm:col-span-2"><Button type="submit" data-testid="profile-save-button">Save changes</Button></div>
          </form>
        </Panel>
        <Panel title="Security"><PasswordForm /></Panel>
      </div>
    </div>
  );
}
